export default __webpack_public_path__ + "static/media/pictogramBeaconAlert128.53058c1b.svg";